// Check a CSS class to know if a module should be imported
window.checkIfModuleShouldBeLoaded = function checkIfModuleShouldBeLoaded(
	selectorToCheck
) {
	if (selectorToCheck !== "") {
		const module = document.querySelectorAll(selectorToCheck);

		if (module[0]) {
			return true;
		}
	}

	return false;
};

// Load JS libraries
window.loadJsLibraries = function loadJsLibraries(libraries) {
	Object.entries(libraries).forEach(([key, value]) => {
		if (window.checkIfModuleShouldBeLoaded(value.cssClassName) === true) {
			import(/* webpackChunkName: "[request]" */ `./${value.fileName}`).then(
				({ default: ObjectClass }) => {
					window.modules[`"${key}"`] = new ObjectClass(value.cssClassName);
				}
			);
		}
	});
};

// Ajax requests
window.ajaxReq = function ajaxReq() {
	if (window.XMLHttpRequest) {
		return new XMLHttpRequest(); // eslint-disable-line
	}

	if (window.ActiveXObject) {
		return new ActiveXObject("Microsoft.XMLHTTP"); // eslint-disable-line no-console
	}

	console.warn("Browser does not support XMLHTTP."); // eslint-disable-line no-console
	return false;
};

// Destroy ScrollMagic scenes
window.destroyScrollMagicScenes = function destroyScrollMagicScenes(scene) {
	if (
		typeof window.loadModulesScrollMagic === "object" &&
		!Array.isArray(window.loadModulesScrollMagic) &&
		window.loadModulesScrollMagic !== null
	) {
		window.loadModulesScrollMagic.destroy(true);
	}
	if (scene === "animations" || scene === null) {
		if (
			typeof window.animationScrollMagic === "object" &&
			!Array.isArray(window.animationScrollMagic) &&
			window.animationScrollMagic !== null
		) {
			window.animationScrollMagic.destroy(true);
		}
	}
};
